import type React from 'react'
import { InfoGlyph } from '../icons/SdGlyphs'
import { RowChevron } from './RowChevron'
import styles from './StationPageLinkRow.module.css'

export interface StationPageLinkRowProps {
  /** The station's own page, `/<locale>/station/<id>`. */
  href: string
  label: string
  /** Analytics hook; the link itself navigates. */
  onTap?: () => void
}

/**
 * SD/StationDetailsLink — Figma 9206:60036: the map panel's way to the
 * station's full page. Info glyph in a 44 `background/secondary` disc,
 * label regularPx16, trailing chevron; HStack gap 12 · p 12/16 (h 68).
 */
export function StationPageLinkRow({
  href,
  label,
  onTap,
}: StationPageLinkRowProps): React.ReactElement {
  return (
    <a
      href={href}
      onClick={onTap}
      className={styles.row}
      data-testid="station-details-station-page-link"
    >
      <span className={styles.iconBacking} aria-hidden="true">
        <InfoGlyph size={22} className={styles.icon} />
      </span>
      <span className={styles.label}>{label}</span>
      <RowChevron />
    </a>
  )
}
